import { render, staticRenderFns } from "./FormExchange.vue?vue&type=template&id=f23aea00&scoped=true"
import script from "./FormExchange.vue?vue&type=script&lang=js"
export * from "./FormExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23aea00",
  null
  
)

export default component.exports